export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#hero" className="flex items-center gap-2 font-heading text-2xl text-background-50">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              小虎看番
            </a>
            <p className="mt-4 max-w-md text-sm leading-6 text-background-300">
              小虎看番是专注补番推荐与口碑番排行的内容站，为你整理高分番列表、冷门佳作与完结番合集。熬夜补番清单已备好，照着片单刷，每一部都值得看完。
            </p>
            <div className="mt-5 flex gap-3">
              {[
                { icon: 'ri-weibo-fill', label: '微博' },
                { icon: 'ri-bilibili-fill', label: 'B站' },
                { icon: 'ri-zhihu-fill', label: '知乎' },
                { icon: 'ri-wechat-fill', label: '微信' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#about"
                  aria-label={s.label}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-background-800/60 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors"
                >
                  <i className={`${s.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-200">栏目导航</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {[
                ['#top', '高分番排行榜'],
                ['#gems', '冷门佳作推荐'],
                ['#completed', '完结番合集'],
                ['#review', '口碑番排行'],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="text-background-300 hover:text-primary-400 transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-background-200">关于小虎</h4>
            <ul className="mt-4 space-y-3 text-sm">
              {[
                ['#about', '关于我们'],
                ['#faq', '常见问题'],
                ['#pick', '本周补番清单'],
                ['#subscribe', '订阅补番清单'],
              ].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="text-background-300 hover:text-primary-400 transition-colors">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">© 2026 小虎看番 · 熬夜补番清单，每一部都值得看完</p>
          <p className="text-xs text-background-400">
            联系我们：<a href="mailto:hello@xiaohu-kanfan.example" className="hover:text-primary-400 transition-colors">hello@xiaohu-kanfan.example</a>
          </p>
        </div>
      </div>
    </footer>
  );
}